<button mat-icon-button (click)="downloadZip()" class="upload-button" matTooltip="Download Zip"
    aria-label="Download Zip">
    <span class="material-icons">download</span>
    {{ downloadZipText }}
</button>